import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getMainSetting } from 'src/shared/functions/getMainSetting';
import { MainSettingsEnum } from 'src/shared/models/enums/mainSettings.enum';
import { MembersCount } from '../models/membersCount';

type StatisticsMemberCountDataGridProps = {
  dataList: MembersCount[];
};

export const StatisticsMemberCountDataGrid = (props: StatisticsMemberCountDataGridProps) => {
  const { dataList } = props;
  const { t } = useTranslation();
  const { currentUser } = useGlobals();

  const totalMembers = useMemo(() => dataList.reduce((sum, m) => sum + (m.memberCount ?? 0), 0), [dataList]);

  const displayDistrict = (currentUser?.districts?.length ?? 0) > 0;

  return (
    <>
      {dataList && dataList.length > 0 ? (
        <>
          <Table size='small' aria-label='members-count' sx={{ width: '100%' }}>
            <TableHead>
              <TableRow
                sx={{
                  '& th': { fontWeight: 600, borderBottom: (v) => `1px solid ${v.palette.divider}` },
                }}
              >
                {displayDistrict && (
                  <TableCell>
                    {getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.CountyLabel, t('statistics:membersCount.district'))}
                  </TableCell>
                )}
                <TableCell>
                  {getMainSetting(currentUser?.mainSettings ?? [], MainSettingsEnum.LocalLabel, t('statistics:membersCount.association'))}
                </TableCell>
                <TableCell>{t('statistics:membersCount.members')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataList.map((item) => (
                <TableRow
                  key={item.id}
                  sx={{
                    '& td': { borderBottom: (v) => `1px solid ${v.palette.divider}` },
                  }}
                >
                  {displayDistrict && <TableCell>{item.district}</TableCell>}
                  <TableCell>{item.association}</TableCell>
                  <TableCell>{item.memberCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Typography mt={1} fontWeight={600} color='text.secondary'>
            {t('statistics:membersCount.total', { count: totalMembers })}
          </Typography>
        </>
      ) : (
        <Typography variant='h5' align='center' sx={{ color: 'grey.500' }} gutterBottom>
          {t('common:statusMessages.noResult')}
        </Typography>
      )}
    </>
  );
};
